import { EarlyAccessCreateUserTypes } from '../actions/types';

/**
 * Initial state for Early Access create user form
 * @typedef {Object} EarlyAccessCreateUserState
 * @property {string|null} firstName - User's first name
 * @property {string|null} lastName - User's last name
 * @property {string|null} username - User's chosen username
 * @property {string|null} password - User's chosen password
 * @property {Array|null} associatedSchools - Schools associated with the user
 * @property {string|null} email - User's email address
 * @property {Object|null} defaultSchool - User's primary school (one of associatedSchools)
 */
const initialState = {
  firstName: null,
  lastName: null,
  username: null,
  password: null,
  associatedSchools: null,
  email: null,
  defaultSchool: null,
  earlyAccessCreateUserStep: 1,
  loading: false,
  error: false,
  success: false,
};

/**
 * Reducer for Early Access create user form state
 * @param {EarlyAccessCreateUserState} state - Current state
 * @param {Object} action - Action object
 * @returns {EarlyAccessCreateUserState} New state
 */
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_FIRST_NAME: {
      const { firstName } = action;
      return {
        ...state,
        firstName,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_LAST_NAME: {
      const { lastName } = action;
      return {
        ...state,
        lastName,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_USERNAME: {
      const { username } = action;
      return {
        ...state,
        username,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_PASSWORD: {
      const { password } = action;
      return {
        ...state,
        password,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_ASSOCIATED_SCHOOLS: {
      const { associatedSchools } = action;
      const { defaultSchool } = state;
      const stillSelected =
        Boolean(defaultSchool) &&
        (associatedSchools || []).some(
          school => school.id === defaultSchool.id,
        );
      return {
        ...state,
        associatedSchools,
        defaultSchool: stillSelected ? defaultSchool : null,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_EMAIL: {
      const { email } = action;
      return {
        ...state,
        email,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_UPDATE_DEFAULT_SCHOOL: {
      const { defaultSchool } = action;
      return {
        ...state,
        defaultSchool,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_STEP: {
      const { earlyAccessCreateUserStep } = action;
      return {
        ...state,
        earlyAccessCreateUserStep,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_IS_LOADING: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_HAS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_REQUEST_IS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    }
    default: {
      return state;
    }
  }
};
